import React, { useState } from 'react';
import QRCode from 'react-qr-code';
import { Box, Dialog as MuiDialog, IconButton, Typography, Button } from '@mui/material';
import { useOutletContext } from '../../../providers';
import CloseIcon from '@mui/icons-material/Close';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import { Iconify } from './iconify';
import { useTheme } from "@mui/material/styles";

interface IQrCodeDialogProps {
  open: boolean;
  onClose: () => void;
}

export const QrCodeDialog: React.FC<IQrCodeDialogProps> = ({ open, onClose }) => {
  const { outlet_details } = useOutletContext();
  const theme = useTheme();
  const isLightMode = theme.palette.mode === "light";
  const [copied, setCopied] = useState(false);

  const targetURL = `${window.location.origin}/public/dashboard?outlet=${outlet_details?.outlet_uuid || ''}`;


  const handleCopyUrlCopy = () => {
    window.navigator.clipboard.writeText(targetURL);

    setCopied(true);

    // Reset after 2 seconds
    setTimeout(() => {
      setCopied(false);
    }, 2000);


  }

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
          maxWidth: "360px",
          //   bgcolor: "#1e1e1e",
          width: "100%",
          margin: 0,
          overflow: "hidden",
          boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.15)",
          backgroundColor: isLightMode ? "#fff" : "inherit"
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        {/* Background that extends behind QR code */}
        <Box
          sx={{
            bgcolor: "#CFDBDE",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "50%", // This controls how far down the background extends
            zIndex: 10,
          }}
        />

        {/* Header */}
        <Box
          sx={{
            pt: 4,
            color: "black",
            pb: 2,
            px: 3,
            fontWeight: 500,
            textAlign: "center",
            position: "relative",
            zIndex: 20,

          }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              color: "black",
              right: 8,
            }}
          >
            <Iconify icon="mdi:close" width={20} />
          </IconButton>

          <Typography
            variant="h6"
            sx={{
              fontSize: "1.25rem",
              fontWeight: 700,
              letterSpacing: "0.5px",
            }}
          >
            QR CODE
          </Typography>

          <Typography
            variant="h5"
            sx={{
              color: "black",
              fontWeight: 600,
              mt: 0.5,
            }}
          >
            {outlet_details?.outlet_name}
          </Typography>
        </Box>

        {/* QR Code */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            px: 3,
            py: 4,
            position: "relative",
            zIndex: 20,
          }}
        >
          <Box
            sx={{
              width: 180,
              height: 180,
              mb: 2,
              border: "1px solid rgba(0,0,0,0.1)",
              borderRadius: "8px",
              p: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <QRCode
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={targetURL}
              viewBox={`0 0 256 256`}
            />
          </Box>

          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              mb: 1,
            }}
          >
            Bar Code
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "grey",
              textAlign: "center",
              mb: 3,
              maxWidth: "280px",
            }}
          >
            Utilize a barcode to give your customers quick and convenient access to your digital menu.
          </Typography>

          {/* Action Buttons */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              width: "100%",
            }}
          >
            <Button
              //   variant="outlined"
              startIcon={<Iconify icon="mdi:printer" width={18} />}
              sx={{
                flex: 1,
                // bgcolor: "rgba(255, 107, 107, 0.1)",
                // color: "#FF6B6B",
                border: "none",
                borderRadius: "8px",
                "&:hover": {
                  //   bgcolor: "rgba(255, 107, 107, 0.2)",
                  border: "none",
                },
              }}
            >
              Print
            </Button>

            <Button
              //   variant="outlined"
              startIcon={copied ? <></> : <Iconify icon="mdi:share-variant" width={18} />}
              sx={{
                flex: 1,
                // bgcolor: "rgba(255, 107, 107, 0.1)",
                // color: "#FF6B6B",
                border: "none",
                borderRadius: "8px",
                "&:hover": {
                  //   bgcolor: "rgba(255, 107, 107, 0.2)",
                  border: "none",
                },
              }}
              onClick={handleCopyUrlCopy}
            >
              {copied ? "copied" : "Copy & Share"}
            </Button>
          </Box>
        </Box>
      </Box>
    </MuiDialog>
  );
}; 